export const BUSINESS_TYPE_OPTIONS = Object.freeze([
  { value: 'kiosco', label: 'Kiosco' },
  { value: 'maxikiosco', label: 'Maxikiosco' },
  { value: 'despensa', label: 'Despensa' },
  { value: 'minimercado', label: 'Minimercado' },
  { value: 'supermercado', label: 'Supermercado' },
  { value: 'distribuidora', label: 'Distribuidora' },
  { value: 'carniceria', label: 'Carnicería' },
  { value: 'verduleria', label: 'Verdulería' },
  { value: 'panaderia', label: 'Panadería' },
  { value: 'gastronomia', label: 'Gastronomía' },
  { value: 'ferreteria', label: 'Ferretería' },
  { value: 'farmacia', label: 'Farmacia' },
  { value: 'ropa', label: 'Ropa' },
  { value: 'servicios', label: 'Servicios' },
  { value: 'otro', label: 'Otro' }
]);

const MASS_CONSUMPTION_BUSINESS_TYPES = new Set([
  'kiosco',
  'maxikiosco',
  'despensa',
  'minimercado',
  'supermercado'
]);

const BUSINESS_TYPE_LABELS = Object.freeze(
  Object.fromEntries(BUSINESS_TYPE_OPTIONS.map((option) => [option.value, option.label]))
);

export function normalizeBusinessType(raw) {
  const value = String(raw || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  if (!value) return null;
  return BUSINESS_TYPE_LABELS[value] ? value : null;
}

export function getBusinessTypeLabel(businessType) {
  const normalized = normalizeBusinessType(businessType);
  if (!normalized) return '';
  return BUSINESS_TYPE_LABELS[normalized] || normalized;
}

export function getStarterCatalogRecommendation(businessType) {
  const normalized = normalizeBusinessType(businessType);
  if (!normalized) {
    return {
      eligible: false,
      catalogType: null,
      defaultChecked: false,
      message: 'Seleccioná el tipo de comercio para continuar.'
    };
  }

  if (MASS_CONSUMPTION_BUSINESS_TYPES.has(normalized)) {
    return {
      eligible: true,
      catalogType: 'mass_consumption',
      defaultChecked: true,
      message: 'Se cargarán productos base sin precios ni stock. Luego podrás editarlos.'
    };
  }

  if (normalized === 'distribuidora') {
    return {
      eligible: false,
      catalogType: null,
      defaultChecked: false,
      message: 'Se creará un catálogo vacío. Podrás importar tus productos desde Excel más adelante.'
    };
  }

  return {
    eligible: false,
    catalogType: null,
    defaultChecked: false,
    message: 'Podrás cargar tus productos manualmente o importarlos desde Excel.'
  };
}

export function resolveShouldLoadStarterCatalog(businessType, requested) {
  const recommendation = getStarterCatalogRecommendation(businessType);
  if (!recommendation.eligible) {
    return false;
  }
  if (requested === true || requested === 'true' || requested === 1 || requested === '1') {
    return true;
  }
  if (requested === false || requested === 'false' || requested === 0 || requested === '0') {
    return false;
  }
  return recommendation.defaultChecked;
}

const USUARIOS_ORG_ADMIN_ROLES = new Set(['OWNER', 'MANAGER', 'ADMIN', 'admin', 'gerente']);
const COMPANY_ADMIN_ROLES = new Set([
  'administrador',
  'admin',
  'administrator',
  'gerente',
  'manager'
]);

function normalizeCompanyRol(rol) {
  return String(rol || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Espejo UI de orgCatalogAdminAccess (backend). Solo oculta botón; no reemplaza validación server-side. */
export function canLoadStarterCatalogAsOrgAdmin({ usuariosOrgRoles, companyUserRol, companyUserRolId } = {}) {
  const roles = Array.isArray(usuariosOrgRoles) ? usuariosOrgRoles : [];
  if (
    roles.some((role) => {
      const trimmed = String(role || '').trim();
      const upper = trimmed.toUpperCase();
      if (USUARIOS_ORG_ADMIN_ROLES.has(upper)) return true;
      return USUARIOS_ORG_ADMIN_ROLES.has(trimmed);
    })
  ) {
    return true;
  }

  const rolNorm = normalizeCompanyRol(companyUserRol || companyUserRolId);
  if (rolNorm && COMPANY_ADMIN_ROLES.has(rolNorm)) return true;

  return false;
}
